import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ContentHubIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00012 10.25C2.48135 10.25 1.25015 11.4812 1.25012 12.9999L1.25 18.9999C1.24997 20.5188 2.4812 21.75 4 21.75H20C21.5188 21.75 22.75 20.5188 22.75 19V13C22.75 11.4812 21.5188 10.25 20 10.25H4.00012ZM8.80006 14.4001C8.46869 13.9582 7.84189 13.8687 7.40006 14.2001C6.95823 14.5314 6.86869 15.1582 7.20006 15.6001L8.40006 17.2001C8.77777 17.7037 9.37054 18.0001 10.0001 18.0001H14.0001C14.6296 18.0001 15.2224 17.7037 15.6001 17.2001L16.8001 15.6001C17.1315 15.1582 17.0419 14.5314 16.6001 14.2001C16.1583 13.8687 15.5315 13.9582 15.2001 14.4001L14.0001 16.0001H10.0001L8.80006 14.4001Z"
                fill="currentColor"
            />
            <path
                d="M6.00013 6.25C4.48138 6.25 3.25018 7.48115 3.25013 8.99989L3.25012 9.07021C3.49307 9.02412 3.7438 9 4.00016 9H20C20.2564 9 20.5071 9.02412 20.7501 9.0702V9C20.7501 7.48122 19.5189 6.25 18.0001 6.25H6.00013Z"
                fill="currentColor"
            />
            <path
                d="M8.00012 2.25C6.48137 2.25 5.25017 3.48117 5.25012 4.99992V5.07019C5.49304 5.02411 5.74374 5 6.00007 5H18C18.2564 5 18.5071 5.02412 18.7501 5.07021V5C18.7501 3.48122 17.5188 2.25 16.0001 2.25H8.00012Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export default ContentHubIcon; 